import { App, NavControllerBase } from 'ionic-angular';
import { CustomerGroupsPage } from '../../pages/customer-groups/customer-groups';
import { CustomerDetailsPage } from '../../pages/customer-details/customer-details';
import { CurrentAccountDetailsPage } from '../../pages/current-account-details/current-account-details';
import { CustomersPage } from '../../pages/customers/customers';
import { CardDetailsPage } from '../../pages/card-details/card-details';
import { UserDetailsPage } from '../../pages/user-details/user-details';
import { CustomerGroupDetailsPage } from '../../pages/customer-group-details/customer-group-details';
import { UsersPage } from '../../pages/users/users';
import { AccountHolder } from '../../app/models/AccountHolder';
import { CardsPage } from '../../pages/cards/cards';
import { RegisterActivitiesPage } from '../../pages/register-activities/register-activities';
import { RegisterActivityDetailsPage } from '../../pages/register-activity-details/register-activity-details';
import { CurrentAccount } from '../../app/models/CurrentAccount';
import { SpecialOffersPage } from '../../pages/special-offers/special-offers';
import { ProductsPage } from '../../pages/products/products';
import { ProductCategoriesPage } from '../../pages/product-categories/product-categories';
import { PosPage } from '../../pages/pos/pos';
import { LoginPage } from '../../pages/login/login';
import { ZonesPage } from '../../pages/zones/zones';
import { PriceListPage } from '../../pages/price-list/price-list';
import { TaxRatesPage } from '../../pages/taxrates/taxrates';
import { UnitsOfMeasurePage } from '../../pages/units-of-measure/units-of-measure';
import { CardTypesPage } from '../../pages/card-types/card-types';
import { OrganizationPage } from '../../pages/organization/organization';
import { CouponTypesPage } from '../../pages/coupon-types/coupon-types';
import { CouponsPage } from '../../pages/coupons/coupons';
import { PrintCardPage } from '../../pages/print-card/print-card';
import { PrintsPage } from '../../pages/prints/prints';
import { CardReaderLoginPage } from '../../pages/card-reader-login/card-reader-login';
import { PosAppPage } from '../../pages/pos-app/pos-app';
import { RegisterActivityTransactionsPage } from '../../pages/register-activity-transactions/register-activity-transactions';
import { Storage } from '../../../node_modules/@ionic/storage';
import { CurrentAccountsPage } from '../../pages/current-accounts/current-accounts';
import { Type } from '@angular/core';

interface Args {
  [key: string]: any;
}

export class NavControllerService {
  private navCtrl: NavControllerBase;

  constructor(public app: App, private storage: Storage) {
    this.navCtrl = this.getActiveNav();
  }

  public getActiveNav(): NavControllerBase {
    let navs: NavControllerBase[] = this.app.getActiveNavs();
    if (navs && navs.length) {
      return navs[0];
    }
    return null;
  }

  goTo(page: Type<any>, args?: Args) {
    let activePage = this.navCtrl.getActive();
    if (activePage.component.name !== page.name) {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.push(page, { ...args }).then(() => {
        this.navCtrl.remove(currentIndex);
      });
    }
  }

  showLoginPage() {
    this.goTo(LoginPage)
  }

  showCardReaderLoginPage() {
    this.goTo(CardReaderLoginPage)
  }

  showAccountsOwnersPage(accountHolderType: AccountHolder) {
    switch (accountHolderType) {
      case AccountHolder.Customer:
        this.showCustomersPage();
        break;
      case AccountHolder.User:
        this.showUsersPage();
        break;
    }
  }

  showAccountsOwnerDetails(ownerUuid: string, accountHolderType: AccountHolder) {
    switch (accountHolderType) {
      case AccountHolder.Customer:
        this.showCustomerDetailsPage(ownerUuid);
        break;
      case AccountHolder.User:
        this.showUserDetailsPage(ownerUuid);
        break;
    }
  }

  showCustomerGroupPage() {
    this.goTo(CustomerGroupsPage);
  }

  showCustomerDetailsPage(customerUuid: string) {
    this.goTo(CustomerDetailsPage, { customerUuid: customerUuid });
  }

  showCurrentAccountDetails(currentAccountUuid: string) {
    this.goTo(CurrentAccountDetailsPage, { currentAccountUuid: currentAccountUuid })
  }

  showCurrentAccountsPage() {
    this.goTo(CurrentAccountsPage)
  }

  showCustomersPage() {
    this.goTo(CustomersPage);
  }

  showCardDetails(cardUuid: string, accountHolder: AccountHolder) {
   this.goTo(CardDetailsPage, { cardUuid: cardUuid, accountHolder: accountHolder });
  }

  showUserDetailsPage(userUuid: string) {
    this.goTo(UserDetailsPage, { userUuid: userUuid });
  }

  showUsersPage() {
        let activePage = this.navCtrl.getActive();
    if (activePage.component.name != UsersPage.name) {
      this.isAuthorizedToUserRelatedPages().then((isAuthorized: boolean) => {
        if (isAuthorized) {
          let currentIndex = this.navCtrl.getActive().index;
          this.navCtrl.push(UsersPage).then(() => {
            this.navCtrl.remove(currentIndex);
          });
        }
      });
    }
  }

  showCustomerGroupDetails(customerGroupUuid) {
    this.goTo(CustomerGroupDetailsPage, { customerGroupUuid: customerGroupUuid });
  }

  showCardsPage() {
    this.goTo(CardsPage);
  }

  showSpecialOffersPage() {
    this.goTo(SpecialOffersPage);
  }

  showProductsPage() {
    this.goTo(ProductsPage);
  }

  showProductCategoriesPage() {
    this.goTo(ProductCategoriesPage);
  }

  showPosPage() {
    this.goTo(PosPage);
  }

  showZonesPage() {
    this.goTo(ZonesPage);
  }

  showPosAppPage() {
    this.goTo(PosAppPage);
  }

  showPricelistPage() {
    this.goTo(PriceListPage);
  }

  showTaxRatesPage() {
    this.goTo(TaxRatesPage);
  }

  showUnitsOfMeasurePage() {
    this.goTo(UnitsOfMeasurePage);
  }

  showCardTypesPage() {
    this.goTo(CardTypesPage);
  }

  showRegisterActivitiesPage() {
    this.goTo(RegisterActivitiesPage);
  }

  showOrganizationPage() {
    this.goTo(OrganizationPage);
  }

  showCouponTypesPage() {
    this.goTo(CouponTypesPage);
  }

  showCouponsPage(cardUuid: string) {
    this.goTo(CouponsPage, { cardUuid: cardUuid });
  }

  showRegisterActivityDetails(registerActivityUuid) {
    this.goTo(RegisterActivityDetailsPage, { registerActivityUuid: registerActivityUuid });
  }

  showRegisterActivityTransactions(registerActivityUuid) {
    this.goTo(RegisterActivityTransactionsPage, { registerActivityUuid: registerActivityUuid });
  }

  showPrintCardPage(cardUuid: string) {
    this.goTo(PrintCardPage, { cardUuid: cardUuid });
  }

  showPrintsPage() {
    this.goTo(PrintsPage);
  }

  isAuthorizedToUserRelatedPages(): Promise<boolean> {
    return this.storage.get('userRole').then((userRole) => {
      switch (userRole) {
        case 'ROLE_SETUP':
        case 'ROLE_ADMIN':
        case 'ROLE_TESORIERE':
        case 'ROLE_INSTALLATORE':
          return true;
        default:
          return false;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/nav-controller/navControllerService.ts